import React from "react";
import AutocompleteInput from "components/FormElements/AutocompleteInput";
import { useAuth } from "hooks/Auth";
import { apiGet } from "helpers/Request";
import { transform as userTransformer } from "schemas/User";

export default function UserField(props) {
    const auth = useAuth();

    return (
        <AutocompleteInput
            label="Email Users"
            name={props.name}
            onRequestSearch={async (term) => {
                const items = await apiGet("/v4/search", auth.publication, {
                    keyword: term,
                    per_page: 5,
                    type: "user",
                });

                return userTransformer(items).map((item) => {
                    return {
                        label: item.name,
                        value: item.uuid,
                    };
                });
            }}
        />
    );
}
